/**
 * Проложить маршрут до машины.
 *
 * Маршрут не рисуется у нас на карте: своя отрисовка потребовала бы
 * маршрутизатора, а дала бы линию без голоса, без пробок и без перестроения
 * на ходу. Точка отдаётся картам телефона — они это уже умеют.
 *
 * Какие карты открыть, решает человек, а не приложение: на айфоне у одних
 * стоит Google, у других нет, и угадывать за них незачем.
 *
 * Состоянием владеет тот, кто ставит кнопку. На странице по ссылке тот же
 * выбор открывается нажатием на саму машинку на карте, и двум способам
 * открыть одно окно нужна одна переменная, а не две.
 */

import { appleMapsUrl, googleMapsUrl } from './maps'
import { dict, type Lang } from './i18n'

type Props = {
  latitude: number | null
  longitude: number | null
  label: string
  lang: Lang
  open: boolean
  onOpen: () => void
  onClose: () => void
}

export function RouteButton({ latitude, longitude, label, lang, open, onOpen, onClose }: Props) {
  const t = dict(lang)
  const apple = appleMapsUrl(latitude, longitude, label)
  const google = googleMapsUrl(latitude, longitude, label)

  // Вести некуда — и предлагать нечего. Кнопка, которая никуда не ведёт, хуже
  // её отсутствия: человек нажмёт и решит, что сломалось.
  if (!apple || !google) return null

  if (!open) {
    return (
      <button className="act ghost" onClick={onOpen}>
        {t.routeAction}
      </button>
    )
  }

  return (
    <>
      <p className="hint">{t.routeFixed}</p>
      <a className="act share" href={apple} target="_blank" rel="noopener noreferrer">
        {t.routeApple}
      </a>
      <a className="act share" href={google} target="_blank" rel="noopener noreferrer">
        {t.routeGoogle}
      </a>
      <button className="act ghost" onClick={onClose}>
        {t.confirmNo}
      </button>
    </>
  )
}
